@if (sortedHotels().length > 0) {
	@for (hotel of sortedHotels(); track hotel.slug) {
		<vp-persuade-card
			[cardUrl]="baseUrl() + '/' + hotel.slug"
			[content]="hotel.content"
			[ctaText]="'global.book-directly' | translate"
			[ctaUrl]="
				hotel.availability.isBookable &&
				bookingtoolUrl + '?hotelSlug=' + hotel.slug
			"
			[images]="hotel.images"
			[overline]="hotel.countryCode"
			[price]="
				showPrices() && hotel.availability.isBookable && hotel.price
			"
			[pricingToolTip]="{
				occupancy: pricingTooltipOccupancy,
			}"
			[showReadMore]="true"
			[socialProof]="
				hotel.rating && {
					score: hotel.rating.score,
					numberOfRatings: hotel.rating.numberOfRatings,
				}
			"
			[title]="hotel.name"
		/>
	}
} @else {
	<vp-alert
		[content]="
			'storyblok.pages.filterable-list.no-results.description' | translate
		"
		[emphasized]="true"
		[title]="'storyblok.pages.filterable-list.no-results.title' | translate"
		type="dialog--warning"
	/>
}
